import React from 'react';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { configureMailRequirement } from '../../store/signup/signupAction';
import Header from '../../components/Header';

import './RegisterEmailService.scss';

/**
 * Register email services component
 * @param {*} param0
 */
const RegisterEmailService = ({ configureMailRequirement }) => {
    const history = useHistory();
    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: document.location.pathname,
            title: ''
        }
    });
    return (
        <div className="container">
            <Header />
            <div className="type1-container reg-email-container">
                <h1>
                    Do you want us to setup a business email service for you?
                </h1>
                <div className="centerd-btn-block">
                    <button
                        onClick={() => {
                            history.push('/registration');
                            configureMailRequirement(true);
                        }}
                        className="btn-primary"
                    >
                        Yes, Proceed
                    </button>
                    <button
                        onClick={() => {
                            history.push('/registration');
                            configureMailRequirement(false);
                        }}
                        className="btn-secondary"
                    >
                        No
                    </button>
                </div>

                <div className="faq-section">
                    <h2>FAQ</h2>
                    <div className="faq-item">
                        <h3>What is a business email?</h3>
                        <p>
                            Business emails are professional emails set up
                            exclusively for your company and contain your domain
                            name in the address: yourname@yourcompany.com.
                        </p>
                    </div>
                    <div className="faq-item">
                        <h3>How does a business email help my business?</h3>
                        <p>Business emails help you:</p>
                        <ul>
                            <li>
                                <strong>Promote your brand</strong>: Project
                                your brand name with every email communication
                                you make and reinforce it in the minds of your
                                customers, prospects, and stakeholders.
                            </li>
                            <li>
                                <strong>Earn customer trust</strong>: Instill
                                trust in your customer by conveying the
                                authenticity of your business through
                                professional emails. This builds faith and helps
                                you win more business.{' '}
                            </li>
                            <li>
                                <strong>Ensure Consistency</strong>: Deliver a
                                consistent user experience, inside and outside
                                your company, by adhering to a standard format.
                            </li>
                            <li>
                                <strong>
                                    Reduce spam and achieve a better response
                                    rate
                                </strong>
                                : Minimize the instances of your emails getting
                                marked as spam and achieve better responses
                                through branded emails.{' '}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (store) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    needMailServer: get(store, 'signupReducer.needMailServer', null),
});
const mapDispatchToProps = {
    configureMailRequirement,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterEmailService);
